import z from "zod";
import { ProjectIdSchema, UserIdSchema } from "./idTypes";

// GET /users/me — identity + the persisted "landing project" pointer.
// Permission/tenancy data lives on GET /context.
export const MeResponseSchema = z.object({
  userId: UserIdSchema,
  // Format-validating an email our own backend already owns adds no value and
  // rejects RFC-valid addresses Zod's regex misses — failing the whole profile
  // load (blanking the user) over a field we only ever display.
  email: z.string(),
  name: z.string(),
  createdAt: z.string().optional(),
  defaultProjectId: ProjectIdSchema.optional(),
});
export type MeResponse = z.infer<typeof MeResponseSchema>;
